import { render, staticRenderFns } from "./AttendanceCrud.vue?vue&type=template&id=08313224"
import script from "./AttendanceCrud.vue?vue&type=script&lang=js"
export * from "./AttendanceCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports